<template>
  <footer data-testid="LpFooter">
    <div
      :class="{
        'container mx-auto w-[58%]': true,
      }"
    >
      <div
        :class="{
          'text-xs leading-5': true,
        }"
      >
        <div
          :class="{
            'mx-auto flex flex-wrap justify-center py-40px sm:justify-start lg:flex-row': true,
          }"
        >
          <div
            :class="{
              'text-center text-www-color-neutral-medium-dark sm:text-left': true,
            }"
          >
            {{ copyright }}
          </div>
          <div
            :class="{
              'mx-auto': true,
            }"
          >
            <ul
              :class="{
                'm-0 list-none p-0 text-center sm:text-left': true,
              }"
            >
              <li
                v-for="(menu, index) in footnoteLinks"
                :key="index"
                :class="{
                  'mr-5 inline-block last:mr-0': true,
                }"
              >
                <GeneralLink
                  v-bind="menu"
                  role="menuitem"
                  target="_self"
                  :class="{
                    'text-www-color-accent-blue hover:text-www-color-neutral-dark': true,
                  }"
                  @click="
                    () => {
                      if (
                        menu.link &&
                        menu.link[0] &&
                        menu.link[0]._type === 'externalLink' &&
                        menu.link[0].url === '#cookie-settings'
                      )
                        handleOpenCookieSettings();
                    }
                  "
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import type { Footer } from '~/sanity/types';
defineProps<Footer>();
const oneTrustReady = ref(false);

const pollOneTrust = () => {
  if (import.meta.server) {
    return;
  }
  const interval = setInterval(() => {
    if (!window.OneTrust) {
      return;
    }
    clearInterval(interval);
    oneTrustReady.value = true;
  }, 300);
  setTimeout(() => clearInterval(interval), 20000);
};

pollOneTrust();
const handleOpenCookieSettings = () => {
  if (import.meta.server) return;
  if (!oneTrustReady.value) {
    console.warn('OneTrust is not ready yet, cannot open cookie settings');
    return;
  }

  window.OneTrust.ToggleInfoDisplay();
};
</script>

<style></style>
